import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function FetPregnancyTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].frozenDetails) {
      return 'N/A';
    }

    if (key === 'genderOfChildren') {
      let gender = '';
      const transferDetails = data[index].frozenDetails.gender;

      if (!transferDetails || transferDetails.length === 0) {
        return 'N/A';
      }

      for (let i = 0; i < transferDetails.length; i++) {
        if (transferDetails[i] === 'Male') {
          gender += 'M ';
        } else if (transferDetails[i] === 'Female') {
          gender += 'F ';
        }
      }

      return gender === '' ? 'N/A' : gender;
    }

    const frozenDetails = data[index].frozenDetails;
    if (frozenDetails[key] === null || frozenDetails[key] === '') {
      return 'N/A';
    }
    return frozenDetails[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={11}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            PREGNANCY OUTCOME
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            {' '}
            <div
              style={{
                height: '60px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              b-HCG Positive (Yes/No)
            </div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>1st b-HCG</TableCell>
          <TableCell style={{ fontWeight: 700 }}>2nd b-HCG</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Biochemical Pregnancy (0/1)
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>No. of SAC</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Clinical Pregnancy (0/1)
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>FHR (0/1)</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Ectopic Pregnancy/ Misccariage
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>No. of Children</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Gender</TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            Comments
          </TableCell>
        </TableRow>

        {data &&
          data.map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('bhcgPositive', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('bhcgValue1', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('bhcgValue2', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('biochemicalPregnany', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfSAC', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('clinicalPregnancyDetailsClinical', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('FHR', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('ectopic', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfChildren', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('genderOfChildren', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('clinicalPregnancyDetailsComments', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default FetPregnancyTable;
